import React, { useState } from "react";
import LayoutDashboard from "layouts/layout-dashboard-collapse";
import { Button } from "react-bootstrap";
import SupplierTable from "./components/SupplierTable";
import Swal from "sweetalert2";
import { useSupplier } from "./SupplierContext";
import { useCanvasHandler } from "hooks/useCanvasHandler";
import CreatePage from "./components/create-page";
import { deleteRequest } from "services/api";

const SupplierPage = () => {
  const { suppliers, refetch, Pagination, handleSearch, filterOptions } =
    useSupplier();
  const [searchQuery] = useState("");

  const { handleError, showCanvasHandler, handleSuccessToast } =
    useCanvasHandler();

  const handleCreate = (e) => {
    e.preventDefault();
    showCanvasHandler(
      "Create",
      <CreatePage
        onSuccess={() => {
          handleSuccessToast(true, "Data createing");
          refetch();
        }}
        onError={handleError}
      />
    );
  };

  const handleUpdate = (e, data) => {
    e.preventDefault();
    showCanvasHandler(
      "Update",

      <CreatePage
        initialData={data}
        onSuccess={() => {
          handleSuccessToast(true, "Data updateding");
          refetch();
        }}
        onError={handleError}
      />
    );
  };

  const handleDelete = async (id) => {
    Swal.fire({
      title: "Apakah Anda yakin?",
      text: "Anda tidak akan dapat mengembalikan ini!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Ya, hapus!",
    }).then(async (result) => {
      if (result.isConfirmed) {
        // Handle delete action
        const response = await deleteRequest(`/supplier/${id}`);

        if (response.success) {
          handleSuccessToast(true, "Data deleted successfully");
          refetch();
        }
      }
    });
  };

  return (
    <LayoutDashboard>
      <div className="container-fluid mt-4">
        <div className="d-flex justify-content-between mb-3">
          {/* <Form.Control
            type="text"
            placeholder="Search supplier..."
            value={searchQuery}
            onChange={(e) => setSearchQuery(e.target.value)}
            className="w-50"
          /> */}
          <SearchInput
            handleSearch={handleSearch}
            filterOptions={filterOptions}
          />
          <Button variant="primary" onClick={handleCreate}>
            + Add Supplier
          </Button>
        </div>

        {/* Filter Supplier */}
        <SupplierTable
          suppliers={suppliers.filter((s) =>
            s.name.toLowerCase().includes(searchQuery.toLowerCase())
          )}
          onEdit={handleUpdate}
          onDelete={handleDelete}
          Pagination={Pagination}
        />
      </div>
    </LayoutDashboard>
  );
};

export default SupplierPage;

const SearchInput = ({ handleSearch, filterOptions }) => {
  // const [search, setSearch] = useState("");
  const [search, setSearch] = useState(filterOptions.search || "");

  return (
    <div className="input-icon">
      <input
        type="text"
        className="form-control"
        placeholder="Search..."
        value={search}
        // onChange={(e) => setSearch(e.target.value)}
        onChange={(e) => setSearch(e.target.value)}
        onKeyDown={handleSearch}
      />
      <span className="input-icon-addon">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          className="icon icon-tabler icon-tabler-search"
          width="24"
          height="24"
          viewBox="0 0 24 24"
          strokeWidth="2"
          stroke="currentColor"
          fill="none"
          strokeLinecap="round"
          strokeLinejoin="round"
        >
          <path stroke="none" d="M0 0h24v24H0z" fill="none" />
          <circle cx="10" cy="10" r="7" />
          <line x1="21" y1="21" x2="15" y2="15" />
        </svg>
      </span>
    </div>
  );
};
